import { render, staticRenderFns } from "./examineDetail.vue?vue&type=template&id=5074fe67&scoped=true"
import script from "./examineDetail.vue?vue&type=script&lang=js"
export * from "./examineDetail.vue?vue&type=script&lang=js"
import style0 from "./examineDetail.vue?vue&type=style&index=0&id=5074fe67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5074fe67",
  null
  
)

export default component.exports